import { useState } from "react";
import ReloadIcon from "assets/refresh-icon.svg";
import LogoIcon from "assets/headerLogo.svg";
import Minimize from "assets/minimize.svg";
import ClearChatModal from "../clear-chat-modal";
import { appDetails } from "config";

const Header = ({
  addClass = "",
  reloadHandle,
  hideChatHandle,
  handleClose,
}) => {
  const title = appDetails?.brandName || "AI Assistant";
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleConfirmAction = () => {
    reloadHandle();
    setShowModal(false);
  };
  return (
    <>
      <header
        className={`bg-chatColor flex flex-row justify-between items-center h-10 pl-4 ${addClass}`}
      >
        <p className="flex flex-row gap-1 text-lg text-ejwhite font-sans ">
          <img
            className="mb-2"
            width={25}
            height={25}
            src={LogoIcon}
            alt={title}
          />
          {title}
        </p>
        <div>
          <button
            className="p-3 hover:cursor-pointer"
            onClick={handleOpenModal}
          >
            <img className=" w-5 h-5 color" src={ReloadIcon} alt="reset" />
          </button>
          <button className="p-3 hover:cursor-pointer" onClick={handleClose}>
            <img className=" w-5 h-5 color" src={Minimize} alt="minimize" />
          </button>
        </div>
      </header>
      <ClearChatModal
        isOpen={showModal}
        onClose={handleCloseModal}
        onConfirm={handleConfirmAction}
        title="Clear Conversation"
        message="Are you sure you want to delete this chat? This action cannot be undone."
        confirmText="Clear"
        cancelText="Cancel"
      />
    </>
  );
};

export default Header;
